import React from 'react';
import I18n from 'i18n-js';
import engineeringGearIcon from 'images/icons/engineering_icon.svg';
import BannerIcon from '@/components/shared/NewDashboard/Cards/LessonCard/BannerIcon';
import { TCITooltip } from '@/components/ui/Tooltip';

interface EngineeringBannerProps {
  className?: string;
  unitColor: string;
  showTooltip?: boolean;
}

const EngineeringBanner = ({ className, unitColor, showTooltip = true }: EngineeringBannerProps) => {
  const tooltipText = I18n.t('lesson_engineering_tooltip');

  const banner = (
    <div className={className} style={{ color: `#${unitColor}` }}>
      <BannerIcon />
      <img
        alt={tooltipText}
        className="tw-absolute tw-inset-x-1/2 tw-z-[1001] tw--translate-x-1/2"
        src={engineeringGearIcon}
      />
    </div>
  );

  if (!showTooltip) return banner;

  // AIDEV-NOTE: tooltip is intentionally hover-only — the banner div has no
  // tabIndex and is non-interactive (purely informational). Keyboard/SR
  // users access the same message via the inner <img alt={tooltipText}>,
  // which is exposed in the accessibility tree. Adding tabIndex={0} would
  // create N tab stops per page (one per lesson card with engineering)
  // for a non-actionable element, which is worse UX than the current
  // setup. Don't add tabIndex without also adding an interactive purpose.
  return (
    <TCITooltip>
      <TCITooltip.Trigger asChild>
        {banner}
      </TCITooltip.Trigger>
      <TCITooltip.Content>{tooltipText}</TCITooltip.Content>
    </TCITooltip>
  );
};

export default EngineeringBanner;
